import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { css } from '@emotion/core';
import { primary_light } from '../../../shared/lib/colors';
import Link from '../../../shared/Link/Link';
import { showHeaderMenu } from '../../../../redux/modules/showHeaderMenu';
import { TagIcon } from './TagLabels';
import CompanyWelcome from '../CompanyWelcome/CompanyWelcome';
import './TagMenu.scss';

class TagMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMegaMenuType: '',
      showMegaMenu: false,
      showCartMenu: false,
      showLogin: false,
    };
  }

  // GET CATEGORIES
  getCategories(type) {
    if (!type) {
      return [];
    }
    // Prodotti o Farmaci
    if (type === 'prodotti' || type === 'farmaci') {
      return this.props.categories.filter(category => category.type === type);
    }
    // TAG
    const tag = this.props.categoryTags.find(t => t.name === type);
    if (tag) {
      return tag.categories;
    }
    return;
  }

  render() {
    const { showMegaMenu, selectedMegaMenuType } = this.state;
    const {
      primaryColor,
      secondaryColor,
      categoryTags,
      categoryTagsLayout,
      headerMenuOpen,
      tagMenuVersion,
      companyWelcome,
    } = this.props;

    const tagMenuStyle = css`
      &.version-1 {
        .container-fluid {
          .desktop-menu {
            @media (min-width: 992px) {
              font-size: 14px;
              font-weight: 500;
              justify-content: space-between;
              align-items: center;
              padding: 0 86px;
              background-color: ${secondaryColor};
              height: 67px;


              & .link .single-tag {
                gap: 10px;
                background-color: transparent;
                margin: 0;
                padding: 11px 17px;
                border-radius: 6px;
                color: #ffff;
              }
            }
          }
          .mobile-menu
            .user-section
            .container
            .open-login
            .login-register-container
            > a,
            .mobile-menu .user-section .welcome-user {
            color: ${secondaryColor};
            font-size: 13px;

            border-radius: 12px;

            &:focus,
            &:hover,
            &.active {
              color: ${secondaryColor};
            }
          }
        }
      }

      &.version-2 {
        .container {
          height: auto;
          background-color: #f8f8f8;
          padding-top: 30px;
          .desktop-menu {
            padding-top: 10px;
            display: flex;
            align-items: center;
            width: 60%;
            max-width: 100%;
            justify-content: center;
            flex-wrap: wrap;
            padding-bottom: 50px;

            @media (min-width: 992px) {
              font-size: 14px;
              font-weight: 700;
              width: unset;
              max-width: 52vw;
              // min-width: 900px;
              justify-content: center;
              align-items: center;
              margin: 0 auto;
            }
            a.link {
              flex: 0 1 auto;
              color: #294c76;
              &:hover {
                text-decoration: none;
                color: #294c76;
              }
              & .single-tag {
                display: flex;
                gap: 10px;
                background-color: #ededed;

                margin: 0;
                padding: 11px 17px;
                border-radius: 6px;
                color: #294c76;
              }
            }
          }
        }

        .mobile-menu
          .user-section
          .container
          .open-login
          .login-register-container
          > a,
        .mobile-menu .user-section .welcome-user {
          color: ${secondaryColor};
          font-size: 13px;
          // background-color: ${primary_light(secondaryColor)};
          border-radius: 12px;

          &:focus,
          &:hover,
          &.active {
            color: ${secondaryColor};
          }
        }
      }

      &.version-3 {
        .container-fluid {
          .desktop-menu {
            gap: 30px;
            margin-top: 10px;
            @media (min-width: 992px) {
              font-size: 12px;
              font-weight: 700;
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              align-items: center;
              gap: 30px;
              background-color: ${primaryColor};
              height: 32px;
            }
            & .link .single-tag {
              gap: 10px;
              background-color: transparent;
              margin: 0;
              padding: 0px 11px;
              border-radius: 6px;
              color: #ffff;
            }
          }

          .mobile-menu
            .user-section
            .container
            .open-login
            .login-register-container
            > a,
          .mobile-menu .user-section .welcome-user {
            color: ${secondaryColor};
            font-size: 13px;
            // background-color: ${primary_light(secondaryColor)};
            border-radius: 12px;

            &:focus,
            &:hover,
            &.active {
              color: ${secondaryColor};
            }
          }
        }
      }
    `;

    const onlyChosenCategoryTag =
      tagMenuVersion === 2 ? categoryTagsLayout : categoryTags;

    const drugsCategories = this.getCategories('farmaci');
    const productsCategories = this.getCategories('prodotti');

    const companyWelcomeModule = this.props.homePageConfiguration.find(item => {
      if (item.moduleType === 'Company_welcome') {
        return item;
      }
      return;
    });

    return (
      <div className={`header-menu ${showMegaMenu ? 'mega-menu-open' : ''}`}>
        <nav className="navbar navbar-expand-lg" role="navigation">
          {/* BOTTOM MENU */}
          <div className="bottom">
            <div
              className={`navbar-collapse collapse ${
                headerMenuOpen ? 'show' : ''
              } justify-between version-${tagMenuVersion}`}
              id="menu"
              css={tagMenuStyle}
            >
              <div
                className={
                  tagMenuVersion !== 2 ? 'container-fluid' : 'container'
                }
              >
                {tagMenuVersion === 2 &&
                companyWelcomeModule &&
                companyWelcome ? (
                  <CompanyWelcome companyWelcome={companyWelcome} />
                ) : null}

                <div className="desktop-menu">
                  {onlyChosenCategoryTag &&
                    onlyChosenCategoryTag.map(tag => (
                      <Link
                        key={tag.name}
                        to={'/tag-categoria/' + tag.name}
                        className={`link ${
                          selectedMegaMenuType === tag.name ? 'active' : ''
                        }`}
                      >
                        <div className="single-tag">
                          {tagMenuVersion === 2 && (
                            <TagIcon
                              type={tag.name}
                              icon={tag.icon}
                              color={primaryColor}
                            />
                          )}

                          {tag.name}
                        </div>
                      </Link>
                    ))}

                  {!!drugsCategories.length && (
                    <Link
                      to="/farmaci"
                      className={`link ${
                        selectedMegaMenuType === 'farmaci' ? 'active' : ''
                      }`}
                    >
                      <div className="single-tag">
                        {tagMenuVersion === 2 && (
                          <TagIcon type={'Farmaci'} color={primaryColor} />
                        )}
                        Farmaci
                      </div>
                    </Link>
                  )}
                  {!!productsCategories.length && (
                    <Link
                      to="/prodotti"
                      className={`link ${
                        selectedMegaMenuType === 'prodotti' ? 'active' : ''
                      }`}
                    >
                      <div className="single-tag">
                        {tagMenuVersion === 2 && (
                          <TagIcon type={'Prodotti'} color={primaryColor} />
                        )}
                        Prodotti
                      </div>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
    categories: state.categories.data.categories,
    categoryTags: state.categories.data.tags,
    categoryTagsLayout: state.categories.data.tagsCardsLayout,
    headerMenuOpen: state.showHeaderMenu.headerMenuOpen,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    homePageConfiguration: state.store.data.home.homePageConfiguration,
  };
}

export default withRouter(
  connect(mapStateToProps, { showHeaderMenu })(TagMenu)
);

//tagMenuVersion 1: linear menu, container-fluid (full-page), height: 67px;
//tagMenuVersion 2: container (centered), composed of cards with icons:
//tagMenuVersion 3: linear menu, container-fluid (full-page), height: 32px;
